import React from 'react';

interface MembersTabProps {
  selectedTeam: any;
  isDark: boolean;
}

const MembersTab: React.FC<MembersTabProps> = ({ selectedTeam, isDark }) => (
    <div className="space-y-8">
        {/* Header */}
        <div className={`cgm-card rounded-2xl p-6 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl`}>
            <h3 className="text-3xl font-bold cgm-text-primary mb-2">Team Members</h3>
            <p className="text-lg cgm-text-secondary">All coaches and athletes in this team</p>
        </div>

        {/* Coaches Section */}
        <div className={`cgm-card rounded-2xl p-6 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl`}>
            <h4 className="text-xl font-bold cgm-text-primary">Coaches ({selectedTeam.coaches.length})</h4>
            <p className="text-sm cgm-text-secondary">Coaching staff</p>

            {selectedTeam.coaches.length > 0 ? (
                <div className="mt-6 space-y-4">
                    {selectedTeam.coaches.map((coach: any, index: number) => (
                        <div key={coach.id} className={`flex items-center justify-between p-4 ${index % 2 === 0 ? 'cgm-list-item' : 'cgm-list-item-alt'}`}>
                            <div className="flex items-center space-x-4">
                                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${isDark ? 'bg-gray-800 text-white' : 'bg-gray-200 text-gray-900'}`}>
                                    {coach.first_name ? coach.first_name.charAt(0).toUpperCase() : coach.username.charAt(0).toUpperCase()}
                                </div>
                                <div>
                                    <div className="font-semibold cgm-text-primary">
                                        {coach.full_name || coach.username}
                                    </div>
                                    <div className="text-sm cgm-text-secondary">
                                        {coach.email}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center space-x-2">
                                <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${(coach.whoop_connected || coach.garmin_connected) ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' : 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'}`}>
                                    <span className={`cgm-status-dot ${(coach.whoop_connected || coach.garmin_connected) ? 'cgm-status-connected' : 'cgm-status-warning'}`} />
                                    <span>{(coach.whoop_connected || coach.garmin_connected) ? 'Connected' : 'Not Connected'}</span>
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-12 cgm-text-secondary">
                    <p>No coaches assigned to this team yet.</p>
                </div>
            )}
        </div>

        {/* Athletes Section */}
        <div className={`cgm-card rounded-2xl p-6 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl`}>
            <h4 className="text-xl font-bold cgm-text-primary">Athletes ({selectedTeam.athletes.length})</h4>
            <p className="text-sm cgm-text-secondary">Team members</p>

            {selectedTeam.athletes.length > 0 ? (
                <div className="mt-6 space-y-4">
                    {selectedTeam.athletes.map((athlete: any, index: number) => (
                        <div key={athlete.id} className={`flex items-center justify-between p-4 ${index % 2 === 0 ? 'cgm-list-item' : 'cgm-list-item-alt'}`}>
                            <div className="flex items-center space-x-4">
                                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${isDark ? 'bg-gray-800 text-white' : 'bg-gray-200 text-gray-900'}`}>
                                    {athlete.first_name ? athlete.first_name.charAt(0).toUpperCase() : athlete.username.charAt(0).toUpperCase()}
                                </div>
                                <div>
                                    <div className="font-semibold cgm-text-primary">
                                        {athlete.full_name || athlete.username}
                                    </div>
                                    <div className="text-sm cgm-text-secondary">
                                        {athlete.email}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center space-x-2">
                                <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${(athlete.whoop_connected || athlete.garmin_connected) ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' : 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'}`}>
                                    <span className={`cgm-status-dot ${(athlete.whoop_connected || athlete.garmin_connected) ? 'cgm-status-connected' : 'cgm-status-warning'}`} />
                                    <span>{(athlete.whoop_connected || athlete.garmin_connected) ? 'Connected' : 'Not Connected'}</span>
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-12 cgm-text-secondary">
                    <p>No athletes assigned to this team yet.</p>
                </div>
            )}
        </div>
    </div>
);

export default MembersTab; 